/************
 * Developed by : Shiva Software Solutions
 * Date : 11-01-2023
 * Descriptions : Route page for erx upload page
 * Dependicies : To use @material-ui/core,react-router-dom,formik
 ************/
import React from 'react';

export const oneMgConfig = [
  {
    //Redirect to erx page
    routes: [
      {
        path: '/1mg',
        component: React.lazy(() => import('./oneMG/index')),
      },
    ],
  },
];
